import { render, staticRenderFns } from "./bookings.vue?vue&type=template&id=29b47f3c&scoped=true"
import script from "./bookings.vue?vue&type=script&lang=js"
export * from "./bookings.vue?vue&type=script&lang=js"
import style0 from "./bookings.vue?vue&type=style&index=0&id=29b47f3c&prod&scoped=true&lang=css"
import style1 from "./bookings.vue?vue&type=style&index=1&id=29b47f3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b47f3c",
  null
  
)

export default component.exports